// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"a9674058","850":"1e92221d"}[chunkId] + ".chunk.js";
};